export default "__VITE_ASSET__CmOtEl1P__"